import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { Reveal } from "../components/Reveal";
import { motion } from "framer-motion";

const LEFT = "https://static.prod-images.emergentagent.com/jobs/1a6cd77e-2c9a-4795-8a43-74a438b91473/images/670099bf48c49af91301c49da440bb4852f3a1d53959508c9526e95e3189cc19.png";
const RIGHT = "https://static.prod-images.emergentagent.com/jobs/1a6cd77e-2c9a-4795-8a43-74a438b91473/images/bb56f623d46d266fcf927cb3abe1727d51f05a2c92edf62217b86c2690b6fc87.png";

const CATS = [
  { name: "Blankets", to: "/shop/blankets", img: "https://static.prod-images.emergentagent.com/jobs/1a6cd77e-2c9a-4795-8a43-74a438b91473/images/fb1e1f3c30df43419bc85c26e939410292e63bf182756a8f492209e4173822ec.png" },
  { name: "Towels", to: "/shop/towels", img: "https://static.prod-images.emergentagent.com/jobs/1a6cd77e-2c9a-4795-8a43-74a438b91473/images/d2b8c05652877d7799ccc692be77a2a482d5cd1b6456d68b4d8b0f333c7acf8f.png" },
  { name: "Fragrance", to: "/shop/fragrance", img: "https://static.prod-images.emergentagent.com/jobs/1a6cd77e-2c9a-4795-8a43-74a438b91473/images/15593c6961eb6a40232efcac2c2ba76e01b4d9a25c0809c61efb9e688163f265.png" },
  { name: "Collections", to: "/shop/collections", img: "https://static.prod-images.emergentagent.com/jobs/1a6cd77e-2c9a-4795-8a43-74a438b91473/images/ce86680a705e2d3945228dac7a353d59ae3ce2b56844bb6468652bfd1f548b1d.png" },
];

export default function Home() {
  const [featured, setFeatured] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { featured: true } }).then((r) => setFeatured(r.data.slice(0, 4)));
  }, []);

  return (
    <div data-testid="home-page">
      {/* DIPTYCH HERO */}
      <section className="relative h-screen min-h-[640px] w-full overflow-hidden">
        <div className="absolute inset-0 grid grid-cols-2">
          <motion.img src={LEFT} alt="rinova lifestyle" initial={{ scale: 1.08 }} animate={{ scale: 1 }}
            transition={{ duration: 1.6, ease: "easeOut" }} className="w-full h-full object-cover" />
          <motion.img src={RIGHT} alt="rinova texture" initial={{ scale: 1.08 }} animate={{ scale: 1 }}
            transition={{ duration: 1.6, ease: "easeOut" }} className="w-full h-full object-cover" />
        </div>
        <div className="absolute inset-0 bg-black/15" />

        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.4 }}
            className="text-white uppercase text-[10px] sm:text-[11px] mb-6" style={{ letterSpacing: "0.25em", fontWeight: 300 }}>
            rinova presents
          </motion.p>
          <motion.h1 initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5, duration: 0.9 }}
            className="font-display text-white uppercase" style={{ fontSize: "clamp(56px, 9vw, 128px)", lineHeight: 0.9, letterSpacing: "-0.02em" }}>
            The Comfort<br />Collection
          </motion.h1>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.75 }}
            className="mt-6 uppercase text-[10px] sm:text-[11px]" style={{ letterSpacing: "0.25em", color: "#B8B8B8", fontWeight: 300 }}>
            Spring Summer 2026
          </motion.p>
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.9 }} className="mt-10">
            <Link to="/shop" data-testid="hero-shop-btn"
              className="bg-white text-black px-9 py-3.5 product-title text-[12px] link-hover">Shop Now</Link>
          </motion.div>
        </div>
      </section>

      {/* CATEGORIES */}
      <section className="px-6 lg:px-20 pt-24">
        <Reveal>
          <p className="util-link text-[11px] caption mb-6">Shop by category</p>
          <h2 className="font-display text-3xl sm:text-4xl uppercase mb-10">Everything the home is made of</h2>
        </Reveal>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {CATS.map((c, i) => (
            <Reveal key={c.name} delay={i * 0.08}>
              <Link to={c.to} data-testid={`home-cat-${c.to.split("/").pop()}`} className="group block">
                <div className="w-full aspect-[4/5] bg-card overflow-hidden">
                  <img src={c.img} alt={c.name} className="w-full h-full object-cover group-hover:opacity-80" style={{ transition: "opacity 400ms ease" }} />
                </div>
                <p className="product-title text-[13px] mt-3">{c.name}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      {/* FEATURED */}
      <section className="px-6 lg:px-20 pt-24">
        <Reveal>
          <div className="flex items-end justify-between mb-10">
            <h2 className="font-display text-3xl sm:text-4xl uppercase">Featured</h2>
            <Link to="/shop" className="util-link text-[11px] link-hover">View all</Link>
          </div>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {featured.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      </section>

      {/* SCIENCE TEASER */}
      <section className="bg-black text-white mt-24">
        <div className="px-6 lg:px-20 py-28 grid lg:grid-cols-2 gap-16 items-center">
          <Reveal>
            <p className="util-link text-[11px] text-white/40 mb-5">The Material Science</p>
            <h2 className="font-display text-4xl sm:text-6xl uppercase leading-[0.95] mb-6">We measure comfort like engineers</h2>
            <p className="text-white/50 leading-relaxed mb-9 max-w-lg text-sm">
              Breathability. Durability. Temperature regulation. Environmental impact. Explore the live
              data behind every natural fibre we weave.
            </p>
            <Link to="/material-science" data-testid="science-teaser-btn"
              className="bg-white text-black px-9 py-3.5 product-title text-[12px] link-hover">Open the Dashboard</Link>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="grid grid-cols-2 gap-px bg-white/15">
              {[["98%", "Breathability index"], ["3×", "Faster moisture wicking"], ["+40%", "Durability vs. synthetic"], ["-62%", "Water footprint"]].map(([n, l]) => (
                <div key={l} className="bg-black p-8">
                  <div className="font-display text-5xl">{n}</div>
                  <div className="util-link text-[10px] text-white/40 mt-3">{l}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
